import { defineComponent as _defineComponent } from 'vue'
import { ref, onMounted } from "vue";
import { DataTableHeader } from "vuetify";
import { UserMasterDepartment } from "@/models/user-master/UserMasterResponse";
import { $delete, useApi } from "@/plugins/api/api";
import { useAlert } from "@/plugins/alert/alert";
import { useConfirm } from "@/plugins/confirm/confirm";
import { Messages } from "@/message";
import SpecialCommitChip from "./SpecialCommitChip.vue";
import UserDepartmentRegist from "../dialog/UserDepartmentRegist.vue";
import UserDepartmentEdit from "../dialog/UserDepartmentEdit.vue";

type Props = {
  userId: number;
};

export default /*#__PURE__*/_defineComponent({
  __name: 'UserDepartmentTable',
  props: {
    userId: null
  },
  setup(__props: any) {

const props = __props as {
  userId: number;
};

const { $get, Paths } = useApi();
const { $alert } = useAlert();
const { $deleteConfirm } = useConfirm();



const headers: DataTableHeader[] = [
  { text: "所属コード", value: "affiliationCode", divider: true },
  { text: "所属名", value: "affiliationName", divider: true },
  { text: "時給単価(円)", value: "amount1", divider: true },
  { text: "通勤単価(円)", value: "amount2", divider: true },
  // { text: "特殊通勤単価(円)", value: "amount3", divider: true },
  // {
  //   text: "特殊通勤",
  //   value: "subSpecialCommit",
  //   divider: true,
  //   width: "100",
  //   align: "center"
  // },
  {
    text: "編集",
    value: "edit",
    divider: true,
    width: "59",
    sortable: false,
    align: "center"
  },
  {
    text: "削除",
    value: "delete",
    width: "59",
    sortable: false,
    align: "center"
  }
];

const items = ref<UserMasterDepartment[]>([]);

const isRegistOpen = ref(false);
const isEditOpen = ref(false);

const item = ref<UserMasterDepartment>();

const onSearch = async () => {
  const response = await $get<UserMasterDepartment[]>(
    `${Paths.userMaster.departments.default}/${props.userId}`
  );
  if (response) items.value = response;
};

const onDelete = async (item: UserMasterDepartment) => {
  const confirm = await $deleteConfirm();
  if (!confirm) return;

  const response = await $delete(
    `${Paths.userMaster.departments.default}/${item.incode}/${item.affiliationId}`
  );
  if (response) {
    $alert("success", Messages.Success.Delete);
    await onSearch();
  }
};

const onRegist = () => {
  isRegistOpen.value = true;
};

const onEdit = (val: UserMasterDepartment) => {
  item.value = val;
  isEditOpen.value = true;
};

onMounted(async () => {
  await onSearch();
});

return { __sfc: true,$get, Paths, $alert, $deleteConfirm, props, headers, items, isRegistOpen, isEditOpen, item, onSearch, onDelete, onRegist, onEdit, SpecialCommitChip, UserDepartmentRegist, UserDepartmentEdit }
}

})